export const WMSOmniScanReturnType = {
    PLACE: "place",
    ITEM: "item",
    CONTAINER: "container",
    SHIPMENT: "shipment"
}

export function getWMSOmniScanReturnTypeTranslations(type) {
    switch (type) {
        case WMSOmniScanReturnType.PLACE:
            return "wms.omniScan.entityType.place"
        case WMSOmniScanReturnType.ITEM:
            return "wms.omniScan.entityType.item"
        case WMSOmniScanReturnType.CONTAINER:
            return "wms.omniScan.entityType.container"
        case WMSOmniScanReturnType.SHIPMENT:
            return "wms.omniScan.entityType.shipment"
        default:
            return ""
    }
}